import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import schoolApi from "../../../api/schoolApi";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import { SessionContext } from "../../SessionProvider";

const Header = (props) => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  console.log("header-props==>", props);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [optionStudents, setOptionStudents] = useState([]);
  const [selectedStudent, setStudent] = useState(null);
  const [optionSession, setOptionSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [sidebar, setSidebar] = useState(false);
  const [userInfoData, setUserData] = useState({});
  const [studentList, setStudentList] = useState([]);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) navigate("/login");

    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        setUserInfo(user);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const logout = () => {
    navigate("/login");
  };

  const getPUBLICBASEURL = () => {
    const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
    return `https://crm.idigischool.com/uploads/`;
    // return `http://localhost:3000/uploads/`;
  };

  const toggleSidebar = () => {
    setSidebar(!sidebar);
    document.querySelector("#sidebar").classList.toggle("active");
  };

  useEffect(() => {
    async function initHeader() {
      try {
        const authTokenDecoded = jwt_decode(sessionStorage.token ? sessionStorage.token : null);
        if (authTokenDecoded) {
          setUserData(authTokenDecoded);
        } else {
          setUserData({});
        }

        let studentList;
        if (authTokenDecoded.userrole === "STUDENT") {
          let arr = [];
          console.log("at%%%%", authTokenDecoded?.id);
          studentList = await schoolApi.getStudentRecords(authTokenDecoded?.id);
          console.log("studentList@!@=>", studentList);
          props.studentList(studentList?.studentRec);
          console.log("studentList@@!=>", studentList?.studentRec);
          if (studentList?.studentRec && typeof studentList.studentRec === "object") {
            let obj = {
              label: `${studentList?.studentRec.firstname} ${studentList?.studentRec.lastname}`,
              value: studentList?.studentRec.id,
              imgurl: studentList?.studentRec?.file_parent_id
                ? `${getPUBLICBASEURL()}${studentList?.studentRec?.file_parent_id
                }/${studentList?.studentRec?.file_id}.${studentList?.studentRec?.filetype
                }`
                : null,
            };

            arr.push(obj);
            console.log("radad=>", arr);
          } else {
            console.error("studentList.studentRec is not a valid object");
          }
          console.log("arra22=>", arr);
          setOptionStudents(arr);

          setStudent(arr[0]);
          props.setStudent(studentList?.studentRec);
          setSession(studentList?.studentRec.id);
          setStudentList(studentList?.studentRec);
        } else {
          let arr = [];
          studentList = await schoolApi.fetchStudentsByParentId(authTokenDecoded?.id);
          console.log('studentList-by-parent-id-->>', studentList);

          studentList?.studentRec.map((res) => {
            let obj = {
              label: res.firstname + " " + res.lastname,
              value: res.id,
              imgurl: studentList?.studentRec?.file_parent_id
                ? `${getPUBLICBASEURL()}${studentList?.studentRec?.file_parent_id
                }/${studentList?.studentRec?.file_id}.${studentList?.studentRec?.filetype
                }`
                : null,
            };
            arr.push(obj);
          });
          console.log("arr->", arr);
          setOptionStudents(arr);
          setStudent(arr[0]);
          console.log('studentList?.studentRec[0]-->>', studentList?.studentRec[0]);

          props.setStudent(studentList?.studentRec[0]);
          setSession(studentList?.studentRec[0]?.id);
          setStudentList(studentList?.studentRec);
        }

       
  
 
      } catch (error) {
      console.log("error=>", error);
      if (error?.response?.status === 401) {
        logout();
      }
    }
  }

    initHeader();
}, [userInfoData.id]);

async function setSession(studentid){
  const sessionList = await schoolApi.fetchSessions();
  console.log("sessionList", sessionList);

  let currentDate = new Date();
  const fetchSelectedSessionResult = sessionList?.result?.find((res) => {
    const startDate = new Date(res.startdate);
    const endDate = new Date(res.enddate);
    return currentDate >= startDate && currentDate <= endDate;
  });
let sessionOptions = [];
let admissionRecord = [];


if (studentid) {
  
  const studentAdmissions = await schoolApi.findAdmissionByStudentId(studentid);
  console.log("Student Admissions:", studentAdmissions);

  if (studentAdmissions?.success) {
    admissionRecord = studentAdmissions?.studentAddmision || [];
  }
}

console.log("Admission Record:", admissionRecord);

if (Array.isArray(sessionList?.result)) {
  sessionList.result.forEach((item) => {
    admissionRecord.forEach((student) => {
      console.log("student", student);

      if (item.id === student.session_id) {
        let obj = { value: item.id, label: item.year };
        sessionOptions.push(obj);

    
      }
    });
  });
}
 // Select the matching session or the first one in the list
 let selectedSession = sessionOptions.find(obj => obj.label === fetchSelectedSessionResult?.year) || sessionOptions[0];

 if (selectedSession) {
   handleSession(selectedSession);
   console.log("Current Selected Session:", selectedSession.value);
 }
setOptionSession(sessionOptions);
}

//useEffect(() => {
//  async function initHeader() {
//    try {
//      const token = sessionStorage.token ? sessionStorage.token : null;
//      const authTokenDecoded = token ? jwt_decode(token) : null;
//
//      if (authTokenDecoded) {
//        setUserData(authTokenDecoded);
//      } else {
//        setUserData({});
//      }
//
//      let studentList;
//      let arr = [];
//
//      if (authTokenDecoded?.userrole === "STUDENT") {
//        console.log("Student ID:", authTokenDecoded?.id);
//        studentList = await schoolApi.getStudentRecords(authTokenDecoded?.id);
//        console.log("Student List:", studentList);
//
//        const studentRec = studentList?.studentRec;
//        if (studentRec && typeof studentRec === "object") {
//          let obj = {
//            label: `${studentRec.firstname} ${studentRec.lastname}`,
//            value: studentRec.id,
//            imgurl: studentRec.file_parent_id
//              ? `${getPUBLICBASEURL()}${studentRec.file_parent_id}/${studentRec.file_id}.${studentRec.filetype}`
//              : null,
//          };
//          arr.push(obj);
//        } else {
//          console.error("Invalid student record format.");
//        }
//
//        setOptionStudents(arr);
//        setStudent(arr[0] || null);
//        props.setStudent(studentRec || {});
//        setStudentList(studentRec || {});
//      } else {
//        studentList = await schoolApi.fetchStudentsByParentId(authTokenDecoded?.id);
//        console.log("Student List (Parent):", studentList);
//
//        if (Array.isArray(studentList?.studentRec)) {
//          arr = studentList.studentRec.map((res) => ({
//            label: `${res.firstname} ${res.lastname}`,
//            value: res.id,
//            imgurl: res.file_parent_id
//              ? `${getPUBLICBASEURL()}${res.file_parent_id}/${res.file_id}.${res.filetype}`
//              : null,
//          }));
//        }
//
//        setOptionStudents(arr);
//        setStudent(arr[0] || null);
//        props.setStudent(studentList?.studentRec?.[0] || {});
//        setStudentList(studentList?.studentRec || []);
//      }
//
//      const sessionList = await schoolApi.fetchSessions();
//      console.log("Session List:", sessionList);
//
//      let currentDate = new Date();
//      let fetchSelectedSessionResult = sessionList?.result?.find((res) => {
//        const startDate = new Date(res.startdate);
//        const endDate = new Date(res.enddate);
//        return currentDate >= startDate && currentDate <= endDate;
//      });
//
//      let sessionOptions = [];
//      let admissionRecord = [];
//console.log("Student List (Parent):");
//
//      if (studentList?.studentRec?.[0].id) {
//        const studentAdmissions = await schoolApi.findAdmissionByStudentId(studentList?.studentRec?.[0].id);
//        console.log("Student Admissions:", studentAdmissions);
//
//        if (studentAdmissions?.success) {
//          admissionRecord = studentAdmissions?.studentAddmision || [];
//        }
//      }
//
//      console.log("Admission Record:", admissionRecord);
//
//      if (Array.isArray(sessionList?.result)) {
//        sessionList.result.forEach((item) => {
//          admissionRecord.forEach((student) => {
//          console.log("student",student);
//          
//            if (item.id === student.session_id) {
//              let obj = { value: item.id, label: item.year };
//              sessionOptions.push(obj);
//
//              if (fetchSelectedSessionResult?.year === obj.label) {
//                handleSession(obj);
//                console.log("Current Selected Session:", obj.value);
//              }
//            }
//          });
//        });
//      }
//
//      setOptionSession(sessionOptions);
//    } catch (error) {
//      console.error("Error:", error);
//      if (error?.response?.status === 401) {
//        logout();
//      }
//    }
//  }
//
//  initHeader();
//}, [userInfoData?.id]); // Ensure correct dependency usage

const handleStudent = (selectedStudent) => {
  console.log("selectedStudentz2@@=>", selectedStudent);
  if (selectedStudent) {
    console.log("first23132", selectedStudent);
    console.log("studentList@!=>", typeof studentList);
    console.log("studentList@@=.>", studentList);
    if (studentList?.length > 0) {
      const result = studentList.filter(
        (student) => student.id === selectedStudent.value
      );
      var newObj = result.reduce((a, b) => Object.assign(a, b), {});

      console.log("newObj=>", newObj);
      console.log("reddsd5423==>", result);
      setStudent(selectedStudent);
      props.setStudent(newObj);
      setSession(selectedStudent.value)
      console.log("selectedStudent.value@@=>", selectedStudent.value);
      props.studentList(selectedStudent.value);
    } else {
      setStudent(selectedStudent);
      props.setStudent(studentList);
      props.studentList(selectedStudent.value);
    }

    //setStudentFromStorageOrDefault(selectedStudent);
  }
};

const handleSession = (selectedSession) => {
  if (selectedSession) {
    setSelectedSessionId(selectedSession?.value);
    setSelectedSession(selectedSession);
    props.sessionList(selectedSession.value);
  }
};

console.log('selected-session-Heade.jsx-->>', selectedSession);

return (
  <>
    <Navbar className="header px-2" bg="" expand="lg" variant="">
      <button
        type="button"
        id="sidebarCollapse"
        className="btn btn-info"
        onClick={toggleSidebar}
      >
        <i className="fas fa-align-left"></i>
      </button>
      <Navbar.Brand href="#home"></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link
            href="#"
            className="p-0 nav-style"
            style={{ fontSize: ".9rem" }}
          >
            {selectedStudent?.imgurl ? (
              <img
                src={selectedStudent?.imgurl}
                alt="profile"
                className="student-profile-picture"
                style={{ height: "40px", width: "40px" }}
              />
            ) : (
              <img
                src={`${getPUBLICBASEURL()}dwps_ajmer/image_2024102442318.png`}
                alt="dummy_profile"
                style={{ height: "40px", width: "40px" }}
              />
            )}
            <Badge style={{ fontSize: ".9rem" }} bg="light" text="dark">
              {userInfoData.firstname} {userInfoData.lastname}
            </Badge>
          </Nav.Link>
          <Form.Group className="mx-3 student-style">
            {console.log("arrstd=>", optionStudents)}
            <Select
              required
              className=" username"
              placeholder="Student Name"
              value={selectedStudent}
              onChange={handleStudent}
              isDisabled={optionStudents.length === 1}
              options={optionStudents}
              isSearchable={false}
            />
            <Form.Control.Feedback type="invalid">
              Please Select Students.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mx-3 student-style">
            <Select
              required
              className="username"
              placeholder="Session"
              value={selectedSession}
              onChange={handleSession}
              options={optionSession}
              isSearchable={false}
            // isDisabled={true}
            />
            <Form.Control.Feedback type="invalid">
              Please Select Session.
            </Form.Control.Feedback>
          </Form.Group>

          <Nav.Link
            href="#"
            className="d-flex p-0 nav-style"
            style={{ alignItems: "center" }}
          >
            <span className="mx-2" style={{ fontSize: ".9rem" }}>
              User Role
            </span>
            <Badge style={{ fontSize: ".9rem" }} bg="success">
              {userInfoData.userrole}
            </Badge>
          </Nav.Link>
        </Nav>

        <Nav className="ml-auto">
          {/* <Nav.Link href="/about" className="notify-style">
              <i className="fa-solid fa-bell"></i>
            </Nav.Link> */}
          {sessionStorage.getItem("token") ? (
            <Button
              variant="btn btn-primary"
              onClick={logout}
              title="Logout"
              className="btn-download"
            >
              <i className="fa-solid fa-right-from-bracket"></i>
            </Button>
          ) : null}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </>
);
};

export default Header;
